import { render } from "./PensionGratuity.vue?vue&type=template&id=6e9f6deb&scoped=true"
import script from "./PensionGratuity.vue?vue&type=script&lang=js"
export * from "./PensionGratuity.vue?vue&type=script&lang=js"

import "./PensionGratuity.vue?vue&type=style&index=0&id=6e9f6deb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e9f6deb"]])

export default __exports__